// extracted by mini-css-extract-plugin
export default {"description":"style_description__qqxrL","fade-in":"style_fade-in__cFuhd","top":"style_top__xUjy4","image":"style_image__LrxIb"};